;(function () {
	function positionCarouselArrows(section) {
		const sliderWrap = section.querySelector('.product-carousel__slider-wrap')
		if (!sliderWrap) return

		const cardMedia = sliderWrap.querySelector('.swiper-slide .card__inner .media')
		const prevBtn = sliderWrap.querySelector('.swiper-button-prev__prod')
		const nextBtn = sliderWrap.querySelector('.swiper-button-next__prod')
		if (!cardMedia || !prevBtn || !nextBtn) return

		const mediaRect = cardMedia.getBoundingClientRect()
		const wrapRect = sliderWrap.getBoundingClientRect()
		if (mediaRect.height === 0) return

		const centerY = mediaRect.top - wrapRect.top + mediaRect.height / 2
		prevBtn.style.top = centerY + 'px'
		nextBtn.style.top = centerY + 'px'
	}

	let prodcarousel = () => {
		$('.product-carousel-section').each(function () {
			let slideEl = $(this).find('.product-carousel__wrapper')
			let prodCountHalf = parseFloat(slideEl.data('count')) + 0.1
			let prodCountTablet = parseFloat(slideEl.data('count-tablet') || 2) + 0.2
			let prodCountMobile = parseFloat(slideEl.data('count-mobile') || 1) + 0.2
			const swiperContainer = $(this).find('.swiper-carousel')[0]
			if ($(this).hasClass('slider_started')) {
				return ''
			}

			$(this).addClass('slider_started')
			let id = $(this).attr('id')

			let prodSwiperParams = {
				centeredSlides: false,
				slidesPerView: prodCountMobile,
				waitForTransition: true,
				preventInteractionOnTransition: true,
				threshold: 10,
				touchRatio: 0.7,
				watchSlidesProgress: true,
				updateOnWindowResize: true,
				loop: true,
				preloadImages: true,
				allowTouchMove: true,
				spaceBetween: 16,
				breakpoints: {
					990: {
						slidesPerView: prodCountTablet,
						spaceBetween: 20,
					},
					1360: {
						slidesPerView: prodCountHalf,
						spaceBetween: 24,
					},
				},
			}

			let swiperSlider = new Swiper(`#${id} .swiper-carousel`, {
				navigation: {
					nextEl: `#${id} .swiper-button-next__prod`,
					prevEl: `#${id} .swiper-button-prev__prod`,
				},
				...prodSwiperParams,
			})

			const self = this
			requestAnimationFrame(() => positionCarouselArrows(self))
		})
	}

	document.addEventListener('DOMContentLoaded', function () {
		prodcarousel()
		window.addEventListener('load', function () {
			document.querySelectorAll('.product-carousel-section').forEach(positionCarouselArrows)
		})
	})

	window.addEventListener('resize', function () {
		document.querySelectorAll('.product-carousel-section').forEach(positionCarouselArrows)
	})

	document.addEventListener('shopify:section:load', function () {
		prodcarousel()
	})

	document.addEventListener('resize', function () {
		prodcarousel()
	})

	document.addEventListener('visibilitychange', function () {
		prodcarousel()
	})

	prodcarousel()
})()

//button-with-underline
if (window.screen.width > 990) {
	let attachedProductCarousel = false

	let carouselSection = document.querySelector('.product-carousel-section')

	let imageContainerCarousel = carouselSection.querySelector(
		'.button--with-underline--container'
	)

	let followMouseCarousel = (event) => {
		if (imageContainerCarousel) {
			imageContainerCarousel.style.left = event.pageX + 'px'
			imageContainerCarousel.style.top = event.pageY + 30 + 'px'
		}
	}

	function showTextCarousel() {
		if (!attachedProductCarousel && imageContainerCarousel) {
			attachedProductCarousel = true
			imageContainerCarousel.style.display = 'block'
			document.addEventListener('pointermove', followMouseCarousel)
		}
	}

	function hideTextCarousel() {
		if (imageContainerCarousel) {
			attachedProductCarousel = false
			imageContainerCarousel.style.display = ''
			document.removeEventListener('pointermove', followMouseCarousel)
		}
	}
}
